module.exports = __webpack_public_path__ + "static/media/firstgoalscorer.10ec29b6.jpg";